import { useCallback } from 'react';
import { followUser, unfollowUser, getFollowers, getFollowing } from '../services/followService';

export const useUserFollow = (userId: string) => {
  const follow = useCallback(async (targetId: string) => {
    await followUser(userId, targetId);
  }, [userId]);

  const unfollow = useCallback(async (targetId: string) => {
    await unfollowUser(userId, targetId);
  }, [userId]);

  const fetchFollowers = useCallback(async () => {
    return await getFollowers(userId);
  }, [userId]);

  const fetchFollowing = useCallback(async () => {
    return await getFollowing(userId);
  }, [userId]);

  // Vérifie si userId suit targetId
  const isFollowing = useCallback(async (userId: string, targetId: string) => {
    const following = await getFollowing(userId);
    return following.includes(targetId);
  }, []);

  return { follow, unfollow, fetchFollowers, fetchFollowing, isFollowing };
};
